import { ReleaseOption, SprintOption } from './types';

/** Empty unless the user is typing — so click/focus shows the full list. */
export function comboboxFilterQuery(isTyping: boolean, inputValue: string): string {
  return isTyping ? inputValue : '';
}

/** Substring + multi-token (space) AND — like typing in Excel filter. */
export function sprintMatchesFilter(s: SprintOption, rawQuery: string): boolean {
  const q = rawQuery.trim().toLowerCase();
  if (!q) return true;
  const hay = [s.state, s.name, s.issueCount != null ? String(s.issueCount) : '']
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  const tokens = q.split(/\s+/).filter(Boolean);
  return tokens.every((t) => hay.includes(t));
}

export function releaseMatchesFilter(r: ReleaseOption, rawQuery: string): boolean {
  const q = rawQuery.trim().toLowerCase();
  if (!q) return true;
  const hay = [
    r.fixVersion,
    r.releaseDate,
    r.minCreated,
    r.maxUpdated,
    r.planStartDate,
    r.planEndDate,
    r.storyCount != null ? String(r.storyCount) : '',
    r.issueCount != null ? String(r.issueCount) : '',
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  const tokens = q.split(/\s+/).filter(Boolean);
  return tokens.every((t) => hay.includes(t));
}
